export default "__VITE_ASSET__BaaE2nSZ__"